import { NavLink } from 'react-router-dom';
import type { NavItem } from './navItems';

// Persistent left sidebar for laptop/desktop (>=1280px), per v6
// architecture §5 — the "office" experience. Tablet gets a lighter
// icon-only rail via the same component, driven purely by Tailwind
// breakpoints so there is one shell, not a separate desktop build.
// Visual treatment matches the production app's `.sidebar`/`.nav-item`:
// near-black rail, gold left-border glow on the active route.
export function Sidebar({ items }: { items: NavItem[] }) {
  return (
    <nav className="hidden shrink-0 flex-col border-r border-ink-border bg-[#0b0c0f] tablet:flex tablet:w-16 desktop:w-64" aria-label="Primary">
      <div className="flex h-16 items-center gap-3 border-b border-ink-border px-3 desktop:px-5">
        <img src="/ps-logo.webp" alt="" className="h-9 w-9 shrink-0 rounded-full object-contain drop-shadow" />
        <div className="hidden min-w-0 desktop:block">
          <p className="truncate text-[13px] font-extrabold uppercase tracking-wide text-white">Portable Services</p>
          <p className="text-[9px] font-semibold uppercase tracking-[0.14em] text-gold-500">Operations Portal</p>
        </div>
      </div>
      <ul className="flex flex-1 flex-col gap-1 overflow-y-auto p-2 desktop:p-3">
        {items.map((item) => (
          <li key={item.to}>
            <NavLink
              to={item.to}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-semibold transition ${
                  isActive
                    ? 'bg-gradient-to-r from-gold-900/50 to-transparent text-gold-200 shadow-[inset_2px_0_0_0_#d5aa3b]'
                    : 'text-slate-400 hover:bg-white/5 hover:text-slate-100'
                } justify-center desktop:justify-start`
              }
              title={item.label}
            >
              <item.icon className="h-[18px] w-[18px] shrink-0" strokeWidth={2} aria-hidden="true" />
              <span className="hidden truncate desktop:inline">{item.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
      <div className="hidden border-t border-ink-border p-4 desktop:block">
        <span className="inline-block rounded-full border border-gold-700 bg-gold-900/40 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide text-gold-200">
          v6
        </span>
      </div>
    </nav>
  );
}
